<template>
  <div id="footer" class="container-fluid">
    <div class="top">
      <div class="title-area">
        <div class="title">秦皇岛富田电气设备有限公司</div>
        <div class="little-title">
          <div class="line"></div>
          <div class="text">先进的综合技术和生产能力</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="address-area">
        <p>地址：河北省秦皇岛市北戴河区牛头崖镇戴河新城25号</p>
        <p>电话：0335-7979008</p>
        <p class="homepageUri">网址：www.hbtomita.com</p>
      </div>
      <div class="route-area">
        <div class="line">
          <span @click="gotoRoute('software')">产品展示</span>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<span @click="gotoRoute('newsinformation')">行业动态</span>
        </div>
        <div class="line">
          <span @click="gotoRoute('hotProduct')">热销产品</span>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<span @click="gotoRoute('contactus')">关于我们</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div>版权所有：秦皇岛富田电气设备有限公司&nbsp;&nbsp;&nbsp;&nbsp;ICP备案编号：冀ICP备2021025143号</div>
      <div class="gongan">
        <img src="../assets/img/gongan.png" />
        冀公网安备 13031002000168号
      </div>
    </div>
  </div>
</template>
<script>
  import config from '@/config'
  import { GoTopStatic } from "@/utils/index"
  export default {
    name: "Footer",
    data() {
      return {
        config: config
      };
    },
    methods: {
      gotoRoute(routeName) {
        let route = {
          name: routeName,
        }
        GoTopStatic()
        this.$router.push(route)
      }
    }
  };
</script>
<style scoped>
  #footer {
    width: 100%;
    height: 100%;
    color: #fff;
    background: #121528;
    overflow: hidden;
    text-align: center;
    padding-top: 48px;
    padding-bottom: 30px;
  }
  .homepageUri {
    display:none;
  }
  #footer .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    margin: 0 auto;
  }

      #footer .top .title-area {
        display: flex;
        flex-direction: column;
        align-items: center
      }

        #footer .top .title-area .title {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 30px;
          color: #FFFFFF;
          line-height: 44px;
        }

        #footer .top .title-area .little-title {
          display: flex;
          justify-content: center;
          align-items: center;
        }

          #footer .top .title-area .little-title .line {
            width: 29px;
            border-top: 1px solid #FFFFFF;
          }

          #footer .top .title-area .little-title .text {
            font-family: Source Han Sans CN;
            font-weight: 300;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 44px;
            padding: 0 10px;
          }

    #footer .address-area {
    }

      #footer .address-area p {
        text-align: left;
      }

    #footer .route-area {
      display:block
    }

      #footer .route-area .line {
        font-family: Source Han Sans CN;
        font-weight: 300;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 39px;
      }
        #footer .route-area .line span {
          cursor: pointer
        }

      #footer .bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        border-top: 1px solid #ffffff22;
        margin: 0 auto;
        margin-top: 30px;
        padding-top: 30px;
      }

    #footer .bottom .gongan {
      display: none !important;
    }

    #footer .bottom > div {
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN;
      font-weight: 300;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 44px;
    }

        #footer .bottom > div img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }

  @media screen and (max-width: 997px) {
    #footer .top {
      flex-direction: column;
      width: 100%;
    }
    .homepageUri {
      display: inline;
    }
    #footer .route-area {
      display: none !important;
    }
    #footer .top .title-area .title {
      font-size: 25px;
    }
    #footer .top .title-area .little-title .line {
      /*display: none;*/
    }

    #footer .address-area {
      display:flex;
      flex-direction:column;
      align-items:center;
      margin: 20px 0;
    }

    #footer .bottom {
      display: block;
      margin-top: 0;
      padding-top: 0;
      border-top: 0;
      width: 90%;
    }

      #footer .bottom > div {
        display: flex;
        justify-content: center;
        text-align: center;
        line-height:1.5;
      }
  }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue